import type { PaymentIntentResponse } from '@nestjs-boilerplate/types';
import { apiClient } from '@/lib/api-client';

/**
 * Creates a Stripe PaymentIntent for adding funds.
 *
 * @param amountPence - Amount in pence (minimum 500 = £5.00)
 * @returns PaymentIntent details including client secret
 */
export async function createPaymentIntent(amountPence: number): Promise<PaymentIntentResponse> {
  return apiClient.fetch<PaymentIntentResponse>('/payments/create-intent', {
    method: 'POST',
    body: JSON.stringify({ amount: amountPence }),
  });
}
